import { useQuery } from '@tanstack/react-query';

import { STAFF_KEYS } from '@/constants/queryKeys';
import { errorUtils } from '@/services/errors';
import { staffService } from '@/services/staff';
import { useStaffSession } from '@/hooks/auth';

const useStaffRoster = () => {
  const { data: session } = useStaffSession();

  return useQuery({
    queryKey: STAFF_KEYS.list(),
    queryFn: async () => errorUtils.unwrap(await staffService.listStaff()),
    enabled: session?.stage === 'ready',
    staleTime: Infinity,
  });
};

export {
  useStaffRoster,
};
